import lang from "quasar/lang/en-US.js"
import iconSet from "quasar/icon-set/svg-mdi-v7.js"
import { Notify,Dialog,Loading } from "quasar"


export const componentsWithDefaults = {  }

export const appConfigKey = "nuxtQuasar"

export const quasarNuxtConfig = {
  lang,
  iconSet,
  components: {"defaults":{}},
  plugins: {Notify,Dialog,Loading},
  config: {"dark":true,"notify":{"position":"top","progress":true}}
}